import React, { useState } from 'react';
import { TableCell, TableRow, Button } from "@mui/material";
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../../assets/images/icon_actions/Delete Icon.svg";
import { Image, Space, Modal } from "antd";
import { NavLink } from "react-router-dom";
import { EveryList } from "./Every";

export const LineTable = (props) => {
    const { classes, headerView, clsx, lines, getColumnWidth, currencyFormat, loadMore, deleteLine,
        productLineHead, onEdit, checkCRUDPermission, capitalizeFirstLetter, roleManagement, idNamingConversion } = props;

    const [lineId, setLineId] = useState('');
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [lineName, setLineName] = useState('');

    const onDelete = (data, i) => {
        setDeleteVisible(true);
        setLineId(i);
        setLineName(data?.product?.productName);
    }

    return (
        <>
            {
                !loadMore || lines === '' ? (
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell className={classes.textAlignCenter} colSpan={productLineHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                    </TableRow>
                ) : (
                    <React.Fragment>
                        {
                            lines && Array.isArray(lines) && lines.length > 0 ? lines.map((data, i) => (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i} >
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 0) }}>
                                        {
                                            roleManagement !== '' && checkCRUDPermission('Customer Product Scheduling', 'view', 'Sales') ?
                                                <NavLink to={'#'} id={idNamingConversion('View_' + data.id, 'customerProductSchedulingLine', 'Link')} onClick={() => onEdit(data, i, true)} className={clsx(classes.color, classes.bold)} style={{ width: getColumnWidth(productLineHead, 0) }}>{data?.product?.productName || '---'}</NavLink> :
                                                <span style={{ width: getColumnWidth(productLineHead, 0) }}>{data?.product?.productName || '---'}</span>
                                        }
                                    </TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 1) }}><span style={{ width: getColumnWidth(productLineHead, 1) }}>{data?.product?.productId || '---'}</span></TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 2) }}><span style={{ width: getColumnWidth(productLineHead, 2) }}></span>{capitalizeFirstLetter(data?.status || '---')}</TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 3) }}><span style={{ width: getColumnWidth(productLineHead, 3) }}>{data?.quantity || '---'}</span></TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 4) }}><span style={{ width: getColumnWidth(productLineHead, 4) }}>{data?.unit?.name || '---'}</span></TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 5) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(productLineHead, 5) }}>{`₹ ${currencyFormat(data?.amount || 0)}`}</span></TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 6) }}><span style={{ width: getColumnWidth(productLineHead, 6) }}>{data?.workflow?.name || '---'}</span></TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 7) }}><span style={{ width: getColumnWidth(productLineHead, 7) }}>{data?.scheduleFrequency?.name || '---'}</span></TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 8) }}><span style={{ width: getColumnWidth(productLineHead, 8) }}>
                                        <EveryList classes={classes} data={data} />
                                    </span>
                                    </TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 9) }}><span style={{ width: getColumnWidth(productLineHead, 9) }}>{data?.schedule_time}</span></TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 10) }}><span style={{ width: getColumnWidth(productLineHead, 10) }}>{data?.batch_automate ? 'Yes' : 'No'}</span></TableCell>
                                    <TableCell>
                                        <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Customer Product Scheduling', 'view', 'Sales') &&
                                                <NavLink to={"#"} id={idNamingConversion('View_' + data.id, 'customerProductSchedulingLine', 'Icon')} onClick={() => onEdit(data, i, true)}>
                                                    <Image src={ViewIcon} preview={false} />
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Customer Product Scheduling', 'edit', 'Sales') && <>
                                                    {
                                                        !headerView && <NavLink id={idNamingConversion('Edit_' + data.id, 'customerProductSchedulingLine', 'Icon')} to={"#"} onClick={() => onEdit(data, i, false)}>
                                                            <Image
                                                                src={EditIcon}
                                                                preview={false}
                                                            />
                                                        </NavLink>
                                                    }
                                                </>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Customer Product Scheduling', 'deletable', 'Sales') && <>
                                                    {
                                                        !headerView &&
                                                        <NavLink to={"#"} id={idNamingConversion('Delete_' + data.id, 'customerProductSchedulingLine', 'Icon')} onClick={() => onDelete(data, i)}>
                                                            <Image
                                                                src={DeleteIcon}
                                                                preview={false}
                                                            />
                                                        </NavLink>
                                                    }
                                                </>
                                            }
                                        </Space>
                                    </TableCell>
                                </TableRow>
                            )) : (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={productLineHead.length}>
                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your Product'}</p>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </React.Fragment>
                )
            }
            <Modal
                title={'Delete Confirmation'}
                open={deleteVisible}
                onOk={() => setDeleteVisible(false)}
                onCancel={() => setDeleteVisible(false)}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                        onClick={() => { setDeleteVisible(false); deleteLine(lineId) }}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => setDeleteVisible(false)}>
                        No
                    </Button>,
                ]}>
                <p>Are you sure you want to <span className={classes.deleteRed}> Delete </span> {lineName}</p>
            </Modal>
        </>

    )
}